import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// Components - imported
import { Avatar, Button } from '@material-ui/core';
import Alert from '../../../common/Alert';
import Logo from '../../../common/Logo';

// Icons
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const AddPrivacy = ({
    slideform1, 
    setSlideForm1,
    slideform2, 
    setSlideForm2,
    privacy,
    setPrivacy, 
    onChange,
    user,
    is_create_page
}) => {

    // Toggle the value of slideform1 to go back to the previous form step
    const goBack = (e) => {
        setSlideForm1(!slideform1);
    }

    // Toggle the slideform1 state variable (go to next page in slide form)
    const todo = (e) => {
        setSlideForm2(!slideform2);
    }

    return (
        <div className="form-transition-element">

            {/* Back Button */}
            {!is_create_page && (
                <div onClick={goBack} className="form__backBtn">
                    <ArrowBackIcon />
                </div>
            )}

            {/* Display the heading */}
            <div>
                <h2>Choose Privacy</h2>
            </div>

            <div className="modal__inputs" style={{flex:1, paddingLeft:'5px'}}>
                <div style={{ padding:'0 10px', display:'flex', flexDirection:'column', alignItems:'flex-start'}}>
                    
                    {/* Public */}
                    <div onClick={() => setPrivacy('public')} className="button-hover-class" style={{margin:'10px 0', display:'flex', justifyContent:'center', alignItems:'center'}}>
                        {privacy === 'public' ? (
                            <div style={{display:'flex', justifyContent:'center', alignItems:'center',height:'16px', width:'16px', border:'2px solid rgb(29, 155, 240)', padding:'2px', borderRadius:'50%', marginRight:'10px'}}>
                                <div style={{height:'100%', width:'100%', background:'rgb(29, 155, 240)', borderRadius:'50%'}}></div>
                            </div>
                        ) : (
                            <div style={{height:'19px', width:'19px', border:'2px solid #cecece', borderRadius:'50%', marginRight:'10px'}}></div>
                        )}
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                            <p style={{margin:'0', fontSize:'1rem', fontWeight: 500}}>Public</p>
                            <p style={{fontSize: '13px'}}>Anyone can view and post.</p>
                        </div>
                    </div>

                    {/* Restricted */}
                    <div onClick={() => setPrivacy('restricted')} className="button-hover-class" style={{margin:'10px 0', display:'flex', justifyContent:'center', alignItems:'center'}}>
                        {privacy === 'restricted' ? (
                            <div style={{display:'flex', justifyContent:'center', alignItems:'center',height:'16px', width:'16px', border:'2px solid rgb(29, 155, 240)', padding:'2px', borderRadius:'50%', marginRight:'10px'}}>
                                <div style={{height:'100%', width:'100%', background:'rgb(29, 155, 240)', borderRadius:'50%'}}></div>
                            </div>
                        ) : (
                            <div style={{height:'19px', width:'19px', border:'2px solid #cecece', borderRadius:'50%', marginRight:'10px'}}></div>
                        )}
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                            <p style={{margin:'0', fontSize:'1rem', fontWeight: 500}}>Restricted</p>
                            <p style={{fontSize: '13px'}}>Anyone can view, but only members can post.</p>
                        </div>
                    </div>
                    
                    {/* Private */}
                    <div onClick={() => setPrivacy('private')} className="button-hover-class" style={{margin:'10px 0', display:'flex', justifyContent:'center', alignItems:'center'}}>
                        {privacy === 'private' ? (
                            <div style={{display:'flex', justifyContent:'center', alignItems:'center',height:'16px', width:'16px', border:'2px solid rgb(29, 155, 240)', padding:'2px', borderRadius:'50%', marginRight:'10px'}}>
                                <div style={{height:'100%', width:'100%', background:'rgb(29, 155, 240)', borderRadius:'50%'}}></div>
                            </div>
                        ) : (
                            <div style={{height:'19px', width:'19px', border:'2px solid #cecece', borderRadius:'50%', marginRight:'10px'}}></div>
                        )}
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                            <p style={{margin:'0', fontSize:'1rem', fontWeight: 500}}>Private</p>
                            <p style={{fontSize: '13px'}}>Only members can view and post.</p>
                        </div>
                    </div>

                    {/* Students Only */}
                    {/* <div onClick={() => setPrivacy('students only')} className="button-hover-class" style={{margin:'10px 0', display:'flex', justifyContent:'center', alignItems:'center'}}>
                        {privacy === 'students only' ? (
                            <div style={{display:'flex', justifyContent:'center', alignItems:'center',height:'16px', width:'16px', border:'2px solid rgb(29, 155, 240)', padding:'2px', borderRadius:'50%', marginRight:'10px'}}>
                                <div style={{height:'100%', width:'100%', background:'rgb(29, 155, 240)', borderRadius:'50%'}}></div>
                            </div>
                        ) : (
                            <div style={{height:'19px', width:'19px', border:'2px solid #cecece', borderRadius:'50%', marginRight:'10px'}}></div>
                        )}
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                            <p style={{margin:'0', fontSize:'1rem', fontWeight: 500}}>Students only</p>
                            <p style={{fontSize: '13px'}}>Only verified students can view and post.</p>
                        </div>
                    </div> */}
                </div>
            </div>

            <Button 
                disabled={!privacy?.length > 0}
                onClick={todo}
                variant="outlined" 
                className={`sidebar__tweet ${privacy?.length > 0 ? 'black' : 'ghost'}`}
                fullWidth
            >
                Next
            </Button>

            <Button 
                onClick={goBack}
                variant="outlined" 
                className="sidebar__tweet heart"
                fullWidth
            >
                Go Back
            </Button>

        </div>
    )
}

AddPrivacy.propTypes = {

}

export default AddPrivacy
